var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgElIconGoogle = function SvgElIconGoogle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 18,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#4285F4",
    fillRule: "evenodd",
    d: "M17.354 9.18c0-.56-.05-1.096-.143-1.612H9.794v3.047h4.239a3.623 3.623 0 0 1-1.572 2.376v1.976h2.545c1.49-1.37 2.348-3.39 2.348-5.788Z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#34A853",
    fillRule: "evenodd",
    d: "M9.794 16.875c2.127 0 3.91-.705 5.212-1.908l-2.545-1.976c-.705.473-1.607.752-2.667.752-2.05 0-3.787-1.386-4.406-3.247H2.757v2.04a7.872 7.872 0 0 0 7.037 4.339Z",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#FBBC05",
    fillRule: "evenodd",
    d: "M5.388 10.496A4.734 4.734 0 0 1 5.141 9c0-.52.09-1.024.247-1.496v-2.04H2.757A7.872 7.872 0 0 0 1.919 9c0 1.27.305 2.473.838 3.537l2.631-2.04Z",
    clipRule: "evenodd"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#EA4335",
    fillRule: "evenodd",
    d: "M9.794 4.257c1.156 0 2.194.397 3.01 1.178l2.26-2.259c-1.364-1.27-3.147-2.051-5.27-2.051a7.872 7.872 0 0 0-7.037 4.338l2.63 2.04c.62-1.86 2.356-3.246 4.407-3.246Z",
    clipRule: "evenodd"
  })));
};
export default SvgElIconGoogle;